// =============================================================================
// Character Creator — all selectable options with CDN thumbnail URLs.
// =============================================================================

const CDN = "https://cdn.fluxuro.ai/static/studio/character-creator";

export const GENDERS = [
  { value: "male", label: "Male", thumbnail: `${CDN}/gender/male_gender.webp` },
  { value: "female", label: "Female", thumbnail: `${CDN}/gender/female_gender.webp` },
];


export const ETHNICITIES = [
  { value: "kurd", label: "Kurd" },
  { value: "arab", label: "Arab" },
  { value: "middle_eastern", label: "Middle Eastern" },
  { value: "russian", label: "Russian" },
  { value: "european", label: "European" },
  { value: "american", label: "American" },
];

export const SKIN_COLORS = [
  { value: "porcelain", label: "Porcelain", thumbnail: `${CDN}/skin_color/Porcelain_skin.webp` },
  { value: "ivory", label: "Ivory", thumbnail: `${CDN}/skin_color/ivory_skin.webp` },
  { value: "fair", label: "Fair", thumbnail: `${CDN}/skin_color/fair_skin.webp` },
  { value: "light_beige", label: "Light Beige", thumbnail: `${CDN}/skin_color/light_beige_skin.webp` },
  { value: "warm_beige", label: "Warm Beige", thumbnail: `${CDN}/skin_color/warm_beige_skin.webp` },
  { value: "sand", label: "Sand", thumbnail: `${CDN}/skin_color/sand_skin.webp` },
  { value: "golden", label: "Golden", thumbnail: `${CDN}/skin_color/golden_skin.webp` },
  { value: "honey", label: "Honey", thumbnail: `${CDN}/skin_color/honey_skin.webp` },
  { value: "caramel", label: "Caramel", thumbnail: `${CDN}/skin_color/caramel_skin.webp` },
  { value: "tawny", label: "Tawny", thumbnail: `${CDN}/skin_color/tawny_skin.webp` },
  { value: "amber", label: "Amber", thumbnail: `${CDN}/skin_color/amber_skin.webp` },
  { value: "chestnut", label: "Chestnut", thumbnail: `${CDN}/skin_color/chestnut_skin.webp` },
  { value: "bronze", label: "Bronze", thumbnail: `${CDN}/skin_color/bronze_skin.webp` },
  { value: "espresso", label: "Espresso", thumbnail: `${CDN}/skin_color/espresso_skin.webp` },
  { value: "mahogany", label: "Mahogany", thumbnail: `${CDN}/skin_color/mahogany_skin.webp` },
  { value: "ebony", label: "Ebony", thumbnail: `${CDN}/skin_color/ebony_skin.webp` },
];

export const EYE_COLORS = [
  { value: "dark_brown", label: "Dark Brown", thumbnail: `${CDN}/eye_color/dark_brown_eye_color.webp` },
  { value: "light_brown", label: "Light Brown", thumbnail: `${CDN}/eye_color/light_brown_eye_color.webp` },
  { value: "hazel", label: "Hazel", thumbnail: `${CDN}/eye_color/hazel_eye_color.webp` },
  { value: "amber", label: "Amber", thumbnail: `${CDN}/eye_color/amber_eye_color.webp` },
  { value: "green", label: "Green", thumbnail: `${CDN}/eye_color/green_eye_color.webp` },
  { value: "blue_green", label: "Blue-Green", thumbnail: `${CDN}/eye_color/blue_green_eye_color.webp` },
  { value: "light_blue", label: "Light Blue", thumbnail: `${CDN}/eye_color/light_blue_eye_color.webp` },
  { value: "deep_blue", label: "Deep Blue", thumbnail: `${CDN}/eye_color/deep_blue_eye_color.webp` },
  { value: "gray", label: "Gray", thumbnail: `${CDN}/eye_color/gray_eye_color.webp` },
  { value: "gray_blue", label: "Gray-Blue", thumbnail: `${CDN}/eye_color/gray_blue_eye_color.webp` },
  { value: "black", label: "Black", thumbnail: `${CDN}/eye_color/black_eye_color.webp` },
  { value: "honey", label: "Honey", thumbnail: `${CDN}/eye_color/honey_eye_color.webp` },
];


export const SKIN_CONDITIONS = [
  { value: "none", label: "None", thumbnail: `${CDN}/skin_condition/clear_skin.webp` },
  { value: "freckles", label: "Freckles", thumbnail: `${CDN}/skin_condition/freckles_skin.webp` },
  { value: "vitiligo", label: "Vitiligo", thumbnail: `${CDN}/skin_condition/vitiligo_skin.webp` },
  { value: "pigmentation", label: "Pigmentation", thumbnail: `${CDN}/skin_condition/pigmentation_skin.webp` },
  { value: "birthmarks", label: "Birthmarks", thumbnail: `${CDN}/skin_condition/birthmarks_skin.webp` },
  { value: "scars", label: "Scars", thumbnail: `${CDN}/skin_condition/scars_skin.webp` },
  { value: "burns", label: "Burns", thumbnail: `${CDN}/skin_condition/burns_skin.webp` },
  { value: "albinism", label: "Albinism", thumbnail: `${CDN}/skin_condition/albinism_skin.webp` },
  { value: "cracked_dry_skin", label: "Cracked Dry", thumbnail: `${CDN}/skin_condition/cracked_dry_skin.webp` },
  { value: "wrinkled_skin", label: "Wrinkled", thumbnail: `${CDN}/skin_condition/vitiligo_skin.webp` },
];

export const BODY_TYPES = [
  { value: "skinny", label: "Skinny", thumbnail: `${CDN}/physique/skinny_physique.webp` },
  { value: "slim", label: "Slim", thumbnail: `${CDN}/physique/slim_physique.webp` },
  { value: "lean", label: "Lean", thumbnail: `${CDN}/physique/lean_physique.webp` },
  { value: "athletic", label: "Athletic", thumbnail: `${CDN}/physique/athletic_physique.webp` },
  { value: "muscular", label: "Muscular", thumbnail: `${CDN}/physique/muscular_physique.webp` },
  { value: "curvy", label: "Curvy", thumbnail: `${CDN}/physique/curvy_physique.webp` },
  { value: "heavy", label: "Heavy", thumbnail: `${CDN}/physique/heavy_physique.webp` },
];

export const HAIR_STYLES_MALE = [
  { value: "buzz_cut", label: "Buzz Cut", thumbnail: `${CDN}/hair_style/male_hair_style/buzz_cut_hair_style.webp` },
  { value: "crew_cut", label: "Crew Cut", thumbnail: `${CDN}/hair_style/male_hair_style/crew_cut_hair_style.webp` },
  { value: "fade_low", label: "Fade (Low)", thumbnail: `${CDN}/hair_style/male_hair_style/fade_low_hair_style.webp` },
  { value: "fade_high", label: "Fade (High)", thumbnail: `${CDN}/hair_style/male_hair_style/fade_high_hair_style.webp` },
  { value: "undercut", label: "Undercut", thumbnail: `${CDN}/hair_style/male_hair_style/undercut_hair_style.webp` },
  { value: "side_part", label: "Side Part", thumbnail: `${CDN}/hair_style/male_hair_style/side_part_hair_style.webp` },
  { value: "slick_back", label: "Slick Back", thumbnail: `${CDN}/hair_style/male_hair_style/slick_back_hair_style.webp` },
  { value: "textured_crop", label: "Textured Crop", thumbnail: `${CDN}/hair_style/male_hair_style/textured_crop_hair_style.webp` },
  { value: "curly_afro_short", label: "Curly / Afro Short", thumbnail: `${CDN}/hair_style/male_hair_style/curly_afro_short_hair_style.webp` },
  { value: "afro_full", label: "Afro Full", thumbnail: `${CDN}/hair_style/male_hair_style/afro_full_hair_style.webp` },
  { value: "braids_cornrows", label: "Braids / Cornrows", thumbnail: `${CDN}/hair_style/male_hair_style/braids_cornrows_hair_style.webp` },
  { value: "man_bun", label: "Man Bun", thumbnail: `${CDN}/hair_style/male_hair_style/man_bun_hair_style.webp` },
  { value: "long_straight", label: "Long Straight", thumbnail: `${CDN}/hair_style/male_hair_style/long_straight_hair_style.webp` },
  { value: "bald", label: "Bald", thumbnail: `${CDN}/hair_style/bald_hair_style.webp` },
];

export const HAIR_STYLES_FEMALE = [
  { value: "pixie_cut", label: "Pixie Cut", thumbnail: `${CDN}/hair_style/female_hair_style/pixie_cut_hair_style.webp` },
  { value: "bob", label: "Bob", thumbnail: `${CDN}/hair_style/female_hair_style/bob_hair_style.webp` },
  { value: "long_straight", label: "Long Straight", thumbnail: `${CDN}/hair_style/female_hair_style/long_straight_hair_style.webp` },
  { value: "long_wavy", label: "Long Wavy", thumbnail: `${CDN}/hair_style/female_hair_style/long_wavy_hair_style.webp` },
  { value: "long_curly", label: "Long Curly", thumbnail: `${CDN}/hair_style/female_hair_style/long_curly_hair_style.webp` },
  { value: "afro", label: "Afro", thumbnail: `${CDN}/hair_style/female_hair_style/afro_hair_style.webp` },
  { value: "box_braids", label: "Box Braids", thumbnail: `${CDN}/hair_style/female_hair_style/box_braids_hair_style.webp` },
  { value: "cornrows", label: "Cornrows", thumbnail: `${CDN}/hair_style/female_hair_style/cornrows_hair_style.webp` },
  { value: "french_braid", label: "French Braid", thumbnail: `${CDN}/hair_style/female_hair_style/french_braid_hair_style.webp` },
  { value: "ponytail_high", label: "Ponytail (High)", thumbnail: `${CDN}/hair_style/female_hair_style/pony_tail_high_hair_style.webp` },
  { value: "low_bun", label: "Low Bun", thumbnail: `${CDN}/hair_style/female_hair_style/low_bun_hair_style.webp` },
  { value: "bangs_long", label: "Bangs + Long", thumbnail: `${CDN}/hair_style/female_hair_style/bangs_long_hair_style.webp` },
  { value: "locs_dreadlocks", label: "Locs / Dreadlocks", thumbnail: `${CDN}/hair_style/female_hair_style/locs_dreadlocks_hair_style.webp` },
  { value: "shaved_buzz", label: "Shaved / Buzz", thumbnail: `${CDN}/hair_style/female_hair_style/shaved_buzz_hair_style.webp` },
];

export const MARKINGS = [
  { value: "none", label: "None", thumbnail: `${CDN}/accessories_marking/no_accessories.webp` },
  { value: "tattoo", label: "Tattoo", thumbnail: `${CDN}/accessories_marking/tattoo_accessories.webp` },
  { value: "piercing", label: "Piercing", thumbnail: `${CDN}/accessories_marking/piercing_accessories.webp` },
  { value: "scarification", label: "Scarification", thumbnail: `${CDN}/accessories_marking/scarification_accessories.webp` },
  { value: "symbols_markings", label: "Symbols / Markings", thumbnail: `${CDN}/accessories_marking/symbol_markings_accessories.webp` },
  { value: "cyber_markings", label: "Cyber Markings", thumbnail: `${CDN}/accessories_marking/cyber_markings_accessories.webp` },
];

export const BREAST_SIZES = [
  { value: "small", label: "Small" },
  { value: "medium", label: "Medium" },
  { value: "large", label: "Large" },
];

export const THIGH_SIZES = [
  { value: "thin", label: "Thin" },
  { value: "normal", label: "Normal" },
  { value: "thick", label: "Thick" },
];

export const NECK_LENGTHS = [
  { value: "short", label: "Short" },
  { value: "medium", label: "Medium" },
  { value: "long", label: "Long" },
];
